(function ( $ ) {

    $( document ).ready( function ( $ ) {

        /**
         * On init function.
         */
        function onInitFunction() {

            var theme_url = object_name.theme_url,
                count = 1;

            const vivus = new Vivus('spinner', {
                duration: 37.5,
                type: 'delayed',
                animTimingFunction: Vivus.EASE,
                file: theme_url + '/assets/img/load.svg'
            }, myCallback);

            function myCallback() {
                if (count === 1) {
                    negative();
                    count++;
                }
                function negative() {
                    vivus.play(-1);
                    setTimeout(function() {
                        positive();
                    }, 1250);
                }
                function positive() {
                    vivus.play(1);
                    setTimeout(function() {
                        negative();
                    }, 1250);
                }
            }

            setTimeout(function() {

                $('.spinner').fadeOut(500, function() {

                    $('.load').fadeIn(500);
                    vivus.stop();

                });

            }, 900);

            smoothScrollFunction();
            navigationFunction();

        }

        /**
         * Smooth Scroll function.
         */
        function smoothScrollFunction() {

           $("a[href^='#']").on("click", function(e) {
              $("html, body").animate({
                scrollTop: $($(this).attr("href")).offset().top
              }, 1000);
              return false;
            });

            if ($(window.location.hash).length > 1) {
              $("html, body").animate({
                scrollTop: $(window.location.hash).offset().top
              }, 1000);
            }

        }

        /**
         * Navigation function.
         */
        function navigationFunction() {
            const isPolicy = document.body.classList.contains('page-template-policy');

            if (isPolicy) {
                $('.main-header').addClass('main-header--fixed');
            }

            $(window).on('scroll', function () {
                if ($(window).scrollTop() > 200) {
                    $('.main-header').addClass('main-header--fixed');
                } else {
                    if (!isPolicy) {
                        $('.main-header').removeClass('main-header--fixed');
                    }
                }
            });
        }

        /**
         * Fire off the functions.
         */
        onInitFunction();

    } );

})( jQuery );
